import { SchemaObject } from '@augloop/types-core';
import { Log, LogCategory } from '@augloop/logging';
/**
 * Use 'SchemaObject.matchesTypesFor' here to avoid importing types from 'types-core' in host-bridge-session, importing more types from 'types-core' will increase package's size.
 */
const checkFirstUserPerceivedResponse = (message) => {
    var _a;
    const addOps = message.ops.filter(op => SchemaObject.matchesTypesFor(op, ['AugLoop_Core_AddOperation']));
    for (const addOp of addOps) {
        for (const item of addOp.items) {
            if (item.body && ((_a = item.body) === null || _a === void 0 ? void 0 : _a.isFirstUserPerceivedResponse)) {
                return true;
            }
        }
    }
    return false;
};
const getTargetCopilotSignalItem = (operations) => {
    const signalOps = operations.filter(op => SchemaObject.matchesTypesFor(op, ['AugLoop_Signals_SignalOperation']));
    for (const signalOp of signalOps) {
        for (const item of signalOp.items) {
            if (item.body && SchemaObject.matchesTypesFor(item.body, ['AugLoop_CopilotChatHistory_CopilotChatHistorySignal', 'AugLoop_Copilot_CopilotInputSignal'])) {
                return item;
            }
        }
    }
    return undefined;
};
export const logTelemetryForSignalOperations = (operations, cv, timestamp, resultSignature, logOp) => {
    const signalItem = getTargetCopilotSignalItem(operations);
    if (!signalItem) {
        return;
    }
    logOp.setDataField('CurrentTimestamp', timestamp); // Logs current time stamp.
    logOp.cv = cv ? cv : '';
    logOp.resultSignature = resultSignature;
    logOp.resourceId = SchemaObject.getTypeNameFor(signalItem.body);
    if (signalItem.contextId) {
        logOp.setDataField('ContextId', signalItem.contextId);
    }
    if (signalItem.sourceTimestamp) {
        logOp.setDataField('SourceTimestamp', signalItem.sourceTimestamp);
    }
    Log.info(0x1e28b1c5 /* tag_4klhf */, LogCategory.CoreDefault, logOp.stop());
};
export const logTelemetryForSignalSyncMessage = (syncMessage, timestamp, resultSignature, logOp) => {
    logTelemetryForSignalOperations(syncMessage.ops, syncMessage.cv, timestamp, resultSignature, logOp);
};
export const logTelemetryForAnnotation = (message, timestamp, resultSignature, checkFirstResponseForStreamAnnotation, logOp) => {
    if (checkFirstResponseForStreamAnnotation && !checkFirstUserPerceivedResponse(message)) {
        return;
    }
    logOp.setDataField('CurrentTimestamp', timestamp); // Logs current time stamp.
    logOp.cv = message.cv;
    logOp.resultSignature = resultSignature;
    logOp.resourceId = message.annotationType;
    Log.info(0x1e28b1c4 /* tag_4klhe */, LogCategory.CoreDefault, logOp.stop());
};
//# sourceMappingURL=performance-event-tracker.js.map